import {Component, OnInit} from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationSettingDto, ProfileDto, ProfilesClient } from 'src/app/api/wallet-api.generated';
import { ProfilesService } from 'src/app/profiles/profiles.service/profiles.service';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';
import { ToastrMessageServiceService } from '../../shared/services/toastr-message/toastr-message-service.service';
import { GlobalConstants } from 'src/app/shared/common/constants';
import {ApplicationFeatures, BalanceTypes} from 'src/app/shared/enums/enums';
import {ConfigurationService} from '../../shared/services/configuration/configuration.service';

const tabName = 'notifications';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications-settings.component.html',
  styleUrls: ['./notifications-settings.component.scss'],
})
export class NotificationsSettingsComponent implements OnInit {

  currentTab: string;

  profiles$: Observable<ProfileDto[]> = this.profilesService.profiles$;

  notificationSettings: NotificationSettingDto[];

  loadFailMsg = _('settings.notifications.settings-load-fail-message');
  updatedFailMsg = _('settings.notifications.settings-updated-fail-message');
  updatedSuccessMsg = _('settings.notifications.settings-updated-success-message');

  isLoading: boolean;

  currencyCodePrefix = GlobalConstants.currencyCodePrefix;

  balanceTypes = BalanceTypes;

  public isEthDisabled: boolean = this.configurationService.checkForDisabledFeature(ApplicationFeatures.ethIntegration);

  constructor(
    private profilesService: ProfilesService,
    private translateService: TranslateService,
    private profilesClient: ProfilesClient,
    private toastrMessageServiceService: ToastrMessageServiceService,
    private configurationService: ConfigurationService,
  ) {}

  ngOnInit(): void {
    this.currentTab = tabName;
    this.loadNotiicationSettings();
  }

  async loadNotiicationSettings() {
    this.isLoading = true;

    try {
      const settings: NotificationSettingDto[] = await this.profilesClient.getNotificationSettings().toPromise();
      this.notificationSettings = settings || [];
    }
    catch(e) {
      this.toastrMessageServiceService.error(this.loadFailMsg);
    }
    finally {
      this.isLoading = false;
    }
  }

  async updatePofileNotificationSetting(newProfileNotificationSetting: NotificationSettingDto) {
    if (!newProfileNotificationSetting) {
      return;
    }

    this.isLoading = true;

    try {
      await this.profilesClient.updateNotificationSettings(newProfileNotificationSetting).toPromise();
      this.toastrMessageServiceService.success(this.updatedSuccessMsg);
    }
    catch(e) {
      this.toastrMessageServiceService.error(this.updatedFailMsg);
    }
    finally {
      this.isLoading = false;
    }
  }
}
